import {useNavigate, useParams} from "react-router-dom";
import {Alert, Card, CardContent, CircularProgress, Typography} from "@mui/material";
import SnackError from "../../components/SnackError";
import React from "react";
import {useGetOperationByIdQuery, usePutOperationByIdMutation} from "./operation_api";
import OperationForm from "./OperationForm";
import {TablesUpdate} from "../../apitypes";


export const OperationEdit = () => {

    const {id} = useParams<"id">()
    const {data, isFetching} = useGetOperationByIdQuery({id: parseInt(id || "")});
    const [put, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePutOperationByIdMutation();
    const navigate = useNavigate();
    const handleSubmit = async function (values: TablesUpdate<"workTask">) {
        const res = await put({id: parseInt(id || "") , body: values})
        if ("data" in res) {
            navigate("..")
        }
    };
    if (!data  || isFetching)
        return <CircularProgress/>;

    if (!data) return <Alert severity={"error"}>Not found</Alert>

    return <Card sx={{mt: "2em"}}>
        <CardContent>
            <Typography variant={"h1"}>{data && data.Name}</Typography>
        </CardContent>
        {isError && <SnackError error={error}/>}
        <OperationForm
            isUpdating={isUpdating}
            onSubmit={handleSubmit}
            onCancel={() => navigate("..", {replace: true})}
            object={data}
        />
    </Card>;
}
